// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ScopeReasonCodesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ScopeReasonCodesQuery = { __typename?: 'Query', scopeChangeReasons: Array<{ __typename?: 'ScopeChangeReason', id: string, name: string }> };

export type ScopeReasonCodesListFragment = { __typename?: 'ScopeChangeReason', id: string, name: string };

export type SaveItemTemplatesMutationVariables = Types.Exact<{
  input: Types.SaveItemTemplatesInput;
}>;


export type SaveItemTemplatesMutation = { __typename?: 'Mutation', saveItemTemplates: { __typename?: 'SaveItemTemplatesResult', itemTemplates?: Array<{ __typename?: 'ItemTemplate', id: string, status: Types.ItemTemplateStatus } | null | undefined> | null | undefined } };

export const ScopeReasonCodesListFragmentDoc = gql`
    fragment ScopeReasonCodesList on ScopeChangeReason {
  id
  name
}
    `;
export const ScopeReasonCodesDocument = gql`
    query ScopeReasonCodes {
  scopeChangeReasons {
    ...ScopeReasonCodesList
  }
}
    ${ScopeReasonCodesListFragmentDoc}`;

/**
 * __useScopeReasonCodesQuery__
 *
 * To run a query within a React component, call `useScopeReasonCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScopeReasonCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScopeReasonCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useScopeReasonCodesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ScopeReasonCodesQuery, ScopeReasonCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScopeReasonCodesQuery, ScopeReasonCodesQueryVariables>(ScopeReasonCodesDocument, options);
      }
export function useScopeReasonCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScopeReasonCodesQuery, ScopeReasonCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScopeReasonCodesQuery, ScopeReasonCodesQueryVariables>(ScopeReasonCodesDocument, options);
        }
export function useScopeReasonCodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScopeReasonCodesQuery, ScopeReasonCodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScopeReasonCodesQuery, ScopeReasonCodesQueryVariables>(ScopeReasonCodesDocument, options);
        }
export type ScopeReasonCodesQueryHookResult = ReturnType<typeof useScopeReasonCodesQuery>;
export type ScopeReasonCodesLazyQueryHookResult = ReturnType<typeof useScopeReasonCodesLazyQuery>;
export type ScopeReasonCodesSuspenseQueryHookResult = ReturnType<typeof useScopeReasonCodesSuspenseQuery>;
export type ScopeReasonCodesQueryResult = Apollo.QueryResult<ScopeReasonCodesQuery, ScopeReasonCodesQueryVariables>;
export const SaveItemTemplatesDocument = gql`
    mutation SaveItemTemplates($input: SaveItemTemplatesInput!) {
  saveItemTemplates(input: $input) {
    itemTemplates {
      id
      status
    }
  }
}
    `;
export type SaveItemTemplatesMutationFn = Apollo.MutationFunction<SaveItemTemplatesMutation, SaveItemTemplatesMutationVariables>;

/**
 * __useSaveItemTemplatesMutation__
 *
 * To run a mutation, you first call `useSaveItemTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemTemplatesMutation, { data, loading, error }] = useSaveItemTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveItemTemplatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveItemTemplatesMutation, SaveItemTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveItemTemplatesMutation, SaveItemTemplatesMutationVariables>(SaveItemTemplatesDocument, options);
      }
export type SaveItemTemplatesMutationHookResult = ReturnType<typeof useSaveItemTemplatesMutation>;
export type SaveItemTemplatesMutationResult = Apollo.MutationResult<SaveItemTemplatesMutation>;
export type SaveItemTemplatesMutationOptions = Apollo.BaseMutationOptions<SaveItemTemplatesMutation, SaveItemTemplatesMutationVariables>;